function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.6 66.85l3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L27.5 53H0c0 1.55.4 3.1 1.2 4.5z",
  fill: "#0066da"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.65 25L29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44A9.06 9.06 0 000 53h27.5z",
  fill: "#00ac47"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57.5c.8-1.4 1.2-2.95 1.2-4.5H59.798l5.852 11.5z",
  fill: "#ea4335"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M43.65 25L57.4 1.2C56.05.4 54.5 0 52.9 0H34.4c-1.6 0-3.15.45-4.5 1.2z",
  fill: "#00832d"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
  fill: "#2684fc"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M73.4 26.5l-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25 59.8 53h27.45c0-1.55-.4-3.1-1.2-4.5z",
  fill: "#ffba00"
});

var SvgGoogleDriveColor = function SvgGoogleDriveColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87.3 78"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default SvgGoogleDriveColor;